/*
 * Filename: d:\projects\AutoFiFront\src\Content\Modals\ModalCta\ModalCta.tsx
 * Path: d:\projects\AutoFiFront
 * Created Date: Wednesday, February 8th 2023, 11:37:52 am
 * Author: Jonathan MAZAT
 *
 * Copyright (c) 2023 Autobuy SAS
 */
import React, { MouseEventHandler, ReactNode } from 'react';
import {CSSTransition} from 'react-transition-group';
import "Content/Modals/MyModal.css";
import ReactDOM from 'react-dom';
import { AiOutlineClose } from 'react-icons/ai';

type MyModalProps= {
  show: boolean,
  onClose: React.MouseEventHandler<HTMLDivElement>,
  footer: JSX.Element,
  title: string,
  children: JSX.Element | ReactNode | JSX.Element[] | ReactNode[],
  className: string,
  closeModal: MouseEventHandler<SVGElement>,
  addCloseCross?: boolean | false,
  themeColor: string
};

const MyModal = (props: MyModalProps) => {
  const wrapper = React.createRef<HTMLDivElement>();
  const MyColor= props.themeColor== "CITYCAR" ? "var(--root-colors-second)" : props.themeColor == "SUV" ? "var(--root-colors-third)" : props.themeColor == "UTILITY" ? "var(--root-colors-fourth)" : props.themeColor == "SEDAN" ? "var(--root-colors-fifth)" : props.themeColor == "BREAK" ? "var(--root-colors-sixth)" : "var(--root-colors-first)";

  return ReactDOM.createPortal(
    <CSSTransition in={props.show} unmountOnExit timeout={{enter: 0, exit: 300}}>
      <div className={"mymodal"} ref={wrapper} onClick={props.onClose}>
        <div className={"mymodal-content "+ props.className} style={{border: `2px solid ${MyColor}`}} onClick={e => e.stopPropagation()}>
        {
          props.addCloseCross ?
            <AiOutlineClose className={"icon_reset"} onClick={props.closeModal} style={{marginTop: "-1.5rem", marginRight: "-3.5rem", color: MyColor}}/>
            : null
        }
          <div className={"mymodal-header"}>
            <h4 className={"mymodal-title"}>{props.title}</h4>
          </div>
          <div className={"mymodal-body"}>{props.children}</div>
          <div className={"mymodal-footer"}>
            {props.footer}
          </div>
        </div>
      </div>
    </CSSTransition>,
    document.getElementById("root")!
  );
};

export default MyModal;
